export const SELCOMMAILNOTIFTYPE_NONE = 'SELCOMMAILNOTIFTYPE_NONE'
export const SELCOMMAILNOTIFTYPE_DIRECT = 'SELCOMMAILNOTIFTYPE_DIRECT'

export const APPMAILNOTIFTYPE_NONE = 'APPMAILNOTIFTYPE_NONE'
export const APPMAILNOTIFTYPE_APPLICANT = 'APPMAILNOTIFTYPE_APPLICANT'
export const APPMAILNOTIFTYPE_DAILY = 'APPMAILNOTIFTYPE_DAILY'
export const APPMAILNOTIFTYPE_WEEKLY = 'APPMAILNOTIFTYPE_WEEKLY'
